<article>
  <app-toolbar>
    <div class="left flex">
      @defer (when redis()) {
        @if (redis()?.firstat.getFullYear() > 2020 || redis()?.lastat.getFullYear() > 2020) {
          @if (redis()?.firstat.getFullYear() > 2020) {
            {{ redis()?.firstat | date: 'MMMM yyyy' }} -
          } @else {
            To
          }
          @if (redis()?.lastat.getFullYear() > 2020) {
            {{ redis()?.lastat | date: 'MMMM yyyy' }} available.
          } @else {
            No data
          }
        } @else {
          <!--          No data available -->
        }
      } @placeholder (minimum 200ms) {
        <i class="mdi mdi-loading mdi-spin-x2"></i>
      }
    </div>
    <div class="right">
      <app-button size="small" [label]="includeThisMonth ? 'Including this month' : 'Excluding this month'" icon="mdi mdi-rotate-3d-variant" (click)="toggleIncludeThisMonth()" />
      <app-button size="small" [title]="wantsPreviousYear() ? 'Click to only show current year' : 'Click to compare to previous year'" [label]="wantsPreviousYear() ? 'Comparing previous year' : 'Only requested year'" icon="mdi mdi-rotate-3d-variant" (click)="toggleComparePrevioousYear()" />
    </div>
  </app-toolbar>
  <main>
    <header>
      <section class="flex">
        <div class="flex-1" title="Selected year" tooltipPosition="left">
          <div>
            {{ year() }}
            <!--
            @if (granularity() === 'month') {
              {{ dates().dates.from | date: 'YYYY' }}
            } @else {
              {{ dates().dates.from | date: 'MMMM yyyy' }}
            }
          --></div>
          <div>{{ stats().total }}</div>
        </div>
        @if (stats()?.previous) {
          <div class="flex-1" title="Previous year" tooltipPosition="left">
            <div>Previous year</div>
            <div>{{ stats().previous }}</div>
          </div>
          <div class="flex-1" [ngClass]="{ worse: stats().diff > 0, better: stats().diff < 0 }">
            <div>Difference</div>
            <div>
              {{ stats().diff }} <span><i class="mdi" [class.mdi-arrow-up-bold]="stats().diff > 0" [class.mdi-arrow-down-bold]="stats().diff < 0"></i> {{ stats().perc }}%</span>
            </div>
          </div>
        }
      </section>
    </header>

    <section class="charts-container">
      <div class="chart chart-a" [style.height.px]="height()">
        <canvas [id]="chartId" (onSelect)="datesSelected($event)"></canvas>
      </div>
      @if (drillInto()) {
        <div class="month-drillinto">
          <div class="can-click" (click)="drillInto.set(null)">
            <div class="title-row">
              <span title="Energy consumption for {{ month() }}, click to return back.">{{ month() }}</span>
            </div>
            <div><i class="mdi mdi-close"></i></div>
          </div>

          <app-echart [telemetry]="drillInto()" [height]="height() - 26 + 'px'" />
        </div>
      }
    </section>
  </main>
</article>

@if (isLoading()) {
  <app-please-wait />
}
